// Shared helpers for rendering a user's display name and avatar initials.
// Pure functions that take explicit fields, so they work for any user record —
// the current signed-in user (TopBar) or an arbitrary row in an admin table.

// Two-letter initials from first + last name; falls back to the first letter of
// the email, then "U".
export function getInitials(firstName, lastName, email) {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  const fromName = `${first[0] || ""}${last[0] || ""}`.toUpperCase();
  if (fromName) return fromName;
  if (email) return email[0].toUpperCase();
  return "U";
}

// "First Last" when available; otherwise the email's local part, then "User".
export function getFullName(firstName, lastName, email) {
  const name = `${firstName || ""} ${lastName || ""}`.trim();
  if (name) return name;
  if (email) return email.split("@")[0];
  return "User";
}
